export { OtpInput, type OtpInputHandle, type OtpInputProps } from './otp-input';
